/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) { //外部资源
  return /^(https?:|mailto:|tel:)/.test(path)
}

// 获取唯一id
export function getid() {
  const r = URL.createObjectURL(new Blob());
  return r.substr(r.lastIndexOf("/") + 1, r.length - 1);
}
  // 深拷贝
export function deepCopy(obj) {
if (typeof obj !== "object" || obj === null) {
  return obj;
}

let copy;

if (Array.isArray(obj)) {
  copy = [];
  for (let i = 0; i < obj.length; i++) {
    copy[i] = deepCopy(obj[i]);
  }
} else {
  copy = {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      copy[key] = deepCopy(obj[key]);
    }
  }
}

return copy;
}

/**
 * 验证对象数组的name和tags字段
 * @param {Array} arr - 要验证的对象数组
 * @returns {Object} 返回验证结果 {valid: boolean, message: string}
 */
export function validateObjectArray(arr,list) {
  if (!Array.isArray(arr)) {
    return { valid: false, message: '输入必须是数组' };
  }

  if (arr.length === 0) {
    return { valid: false, message: '数组不能为空' };
  }
  if(!list||list.length===0){
    return { valid: false, message: '数组不能为空' };
  }
  const tagGroup={}
  const allTags = new Set(); // 用于检查全局tag重复
  const allNames = new Set(); // 用于检查name重复
  var error=[]
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    
    // 检查name是否存在且不为空
    if (!item.name || item.name.trim() === '') {
      return { valid: false, message: `第${i + 1}个对象的组名不能为空` };
    }
    // 检查name是否重复
    if (allNames.has(item.name.trim())) {
      return { valid: false, message: `组名"${item.name}"不能重复` };
    }
    allNames.add(item.name.trim());

    // 检查tags是否存在且为数组
    if (!Array.isArray(item.tags)) {
      return { valid: false, message: `第${i + 1}个对象的样本必须不能为空` };
    }

    // 检查tags不能为空数组
    if (item.tags.length === 0) {
      return { valid: false, message: `${item.name}的样本不能为空` };
    }

    // 检查当前对象的tags内部是否有重复
    const currentTagsSet = new Set();
    for (let j = 0; j < item.tags.length; j++) {
      const tag = item.tags[j];
      if (currentTagsSet.has(tag)) {
        return { valid: false, message: `${item.name}的样本中存在重复值: ${tag}` };
      }
      currentTagsSet.add(tag);
    }

    // 检查当前对象的tags是否与之前的tags重复
    
    for (let j = 0; j < item.tags.length; j++) {
      // debugger
      const tag = item.tags[j];
      const find=list.find(itt=>itt.value==tag)
      // debugger
        // var tag_temp=list[item.tagsNew[j]].ybzero
        var tag_temp=find.ybzero
      // if (allTags.has(tag)) {
      //   console.log(list,j,tag_temp)
      //   error.push(`${item.name}样本值"${tag_temp}"在多个对象中重复出现`)
      // }
      if(tagGroup.hasOwnProperty(tag_temp)){
        tagGroup[tag_temp].push(item.name)
      }else{
        tagGroup[tag_temp]=[item.name]
      }
      allTags.add(tag);
    }
  }
  for(var key in tagGroup){
    if(tagGroup[key].length!=1){
      error.push(`样本值"${key}"在${tagGroup[key].join(",")}重复出现`)
    }
  }
  // debugger
  if(error.length!=0){
    return { valid: false, message: error.join(",") };
  }

  return { valid: true, message: '验证通过' };
}